"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Widget_1 = require("../tools/Widget");
var jquery_1 = __importDefault(require("jquery"));
var KineticScroller = (function (_super) {
    __extends(KineticScroller, _super);
    function KineticScroller(node, config) {
        var _this = _super.call(this, node, config) || this;
        _this.mouseUp = false;
        _this.el.on('touchstart mousedown', _this.config.leftSelector, function () {
            _this.mouseUp = false;
            _this.scrollLeft(true);
        });
        _this.el.on('touchstart mousedown', _this.config.rightSelector, function () {
            _this.mouseUp = false;
            _this.scrollRight(true);
        });
        _this.el.on('touchend mouseup', function () {
            _this.mouseUp = true;
        });
        return _this;
    }
    KineticScroller.prototype.defaultConfig = function () {
        return {
            scrollElement: '.kinetic-scroller',
            minScrollDistance: 100,
            scrollDelay: 250,
            leftSelector: '.kinetic-scroll-left',
            rightSelector: '.kinetic-scroll-right'
        };
    };
    KineticScroller.prototype.scrollLeft = function (repeat) {
        var _this = this;
        if (this.mouseUp) {
            this.mouseUp = false;
            return;
        }
        if (!repeat) {
            this.mouseUp = true;
        }
        jquery_1.default(this.config.scrollElement).stop().animate({
            scrollLeft: this.getPrevScrollPosition()
        }, this.config.scrollDelay, 'linear', function () {
            _this.scrollLeft(repeat);
        });
    };
    KineticScroller.prototype.scrollRight = function (repeat) {
        var _this = this;
        if (this.mouseUp) {
            this.mouseUp = false;
            return;
        }
        if (!repeat) {
            this.mouseUp = true;
        }
        var newScrollPos = Math.max(jquery_1.default(this.config.scrollElement).scrollLeft() + this.config.minScrollDistance, this.getNextScrollPosition());
        jquery_1.default(this.config.scrollElement).stop().animate({
            scrollLeft: newScrollPos
        }, this.config.scrollDelay, 'linear', function () {
            _this.scrollRight(repeat);
        });
    };
    KineticScroller.prototype.getPrevScrollPosition = function () {
        var scroller = this;
        var scrollEl = jquery_1.default(scroller.config.scrollElement);
        var currentPos = scrollEl.scrollLeft();
        var nextPos = 0;
        scrollEl.children().each(function (index, node) {
            var childOffsetLeft = node.offsetLeft;
            if (childOffsetLeft < currentPos) {
                nextPos = childOffsetLeft;
            }
        });
        return nextPos;
    };
    KineticScroller.prototype.getNextScrollPosition = function () {
        var scrollEl = jquery_1.default(this.config.scrollElement);
        var currentPos = scrollEl.scrollLeft();
        var currentRight = currentPos + scrollEl.outerWidth();
        var nextPos = currentPos;
        scrollEl.children().each(function (index, node) {
            var childOffsetLeft = node.offsetLeft;
            if (childOffsetLeft > currentRight) {
                nextPos += ((childOffsetLeft - currentRight) + jquery_1.default(node).width());
                return false;
            }
        });
        return nextPos;
    };
    return KineticScroller;
}(Widget_1.Widget));
exports.KineticScroller = KineticScroller;
